export interface IGetDriversFiltersDto {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
